module.exports = __webpack_public_path__ + "static/img/about-us.983d04f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/syscom/about-us.png
// module id = E8zt
// module chunks = 0